__turbopack_context__.v({
  "appleLogo": "SectionButtonsDialog-module__C4k3Va__appleLogo",
  "arrowIcon": "SectionButtonsDialog-module__C4k3Va__arrowIcon",
  "arrowLabel": "SectionButtonsDialog-module__C4k3Va__arrowLabel",
  "button": "SectionButtonsDialog-module__C4k3Va__button",
  "buttonHero": "SectionButtonsDialog-module__C4k3Va__buttonHero",
  "buttonsRow": "SectionButtonsDialog-module__C4k3Va__buttonsRow",
  "dialogImageWrap": "SectionButtonsDialog-module__C4k3Va__dialogImageWrap",
  "lockWidth": "SectionButtonsDialog-module__C4k3Va__lockWidth",
  "rightIcon": "SectionButtonsDialog-module__C4k3Va__rightIcon",
  "row": "SectionButtonsDialog-module__C4k3Va__row",
});
